'use strict';

var DefaultConsentPolicy = {
  functional: true,
  analytics: true,
  __default: true
};

var getPolicy = function getPolicy(consentPolicyGetter) {
  return typeof consentPolicyGetter === 'function' && consentPolicyGetter() || DefaultConsentPolicy;
};

var shouldMuteNonEssentials = function shouldMuteNonEssentials(policy) {
  return policy.functional === false || policy.analytics === false;
};

var shouldMuteByCategory = function shouldMuteByCategory(policy, category) {
  if (category === 'essential') {
    return false;
  }

  if (category === 'functional' || category === 'analytics') {
    return policy[category] === false;
  }

  return shouldMuteNonEssentials(policy);
};

module.exports = {
  shouldMuteNonEssentials: shouldMuteNonEssentials,
  shouldMuteByCategory: shouldMuteByCategory,
  getPolicy: getPolicy
};
//# sourceMappingURL=consent-policy.js.map